<template>
  <div
    v-if="savedCards.areLoading"
    class="cf-section-loader-container"
  >
    <div class="cf-loader" />
  </div>

  <div
    v-else-if="savedCards.cards.length > 0"
    class="cf-flex cf-flex--column cf-flex--gap-10"
  >
    <div
      v-for="card in savedCards.cards"
      :key="card.creditCardId"
      class="cf-flex cf-flex--column cf-flex--gap-10"
    >
      <label
        class="cf-card cf-card--clickable cf-flex cf-flex--row cf-flex--align-center cf-flex--justify-space-between"
        :for="`selectedCard${card.creditCardId}`"
      >
        <div class="cf-flex cf-flex--row cf-flex--align-center cf-flex--gap-10">
          <!-- Card Select Radio Button -->
          <div
            v-if="canSelectCard && !card.isExpired"
            class="cf-checkbox-input cf-checkbox-input--radio cf-checkbox-input--default cf-checkbox-input--no-label-text"
          >
            <div class="cf-checkbox-input__option">
              <input
                :id="`selectedCard${card.creditCardId}`"
                :checked="modelValue === card.creditCardId"
                class="cf-checkbox-input__input"
                type="radio"
                name="selectedCard"
                :value="card.creditCardId"
                @focus="$emit('saved-card-focus')"
                @input="changeCardHandler($event.target.value)"
              >

              <div class="cf-checkbox-input__label" />
            </div>
          </div>

          <!-- Card Type -->
          <cf-card-type-icon :card-type="card.cardType" />

          <h4 class="cf-title cf-title--4">
            •••• {{ card.displayText }}
          </h4>
        </div>

        <!-- Expiration -->
        <div class="cf-flex cf-flex--row cf-flex--align-center cf-flex--gap-10">
          <p
            v-if="card.isExpired"
            class="cf-subtitle cf-subtitle--3 cf-subtitle--red cf-text-italics"
          >
            Expired
          </p>

          <p
            v-else
            class="cf-subtitle cf-subtitle--3"
          >
            exp. {{ card.expirationDisplay }}
          </p>

          <button
            type="button"
            class="cf-button cf-button--tertiary cf-button--fixed-24"
            :class="{
              'cf-button--loading': savedCards.deletingCardId === card.creditCardId
            }"
            title="Delete Payment Method"
            @click.prevent="deleteCardHandler(card)"
          >
            <span class="cf-icon far fa-trash-alt" />

            <span class="ada-text">Delete Saved Card</span>
          </button>
        </div>
      </label>

      <!-- Cvv Input -->
      <cf-text-input
        v-if="card.requireCvv && card.creditCardId === modelValue"
        class="animation-flip-in-hor-top"
        type="cvv"
        :model-value="cvvInput"
        label="CVV"
        name="cvc"
        autocomplete="cc-csc"
        :validations="{
          required: true,
          cvv: {
            cardType: card.cardType
          }
        }"
        @update:model-value="$emit('cvv-input-change', $event)"
      />
    </div>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import CfCardTypeIcon from '@/view/components/shared/cf-card-type-icon/index.vue';
  import CfTextInput from '@/view/components/shared/cf-text-input/index.vue';


  export default {
    name: 'CfSavedCreditCards',

    components: {
      CfCardTypeIcon,
      CfTextInput
    },

    inject: {
      $validator: {
        from: '$validator'
      }
    },

    props: {
      modelValue: {
        type: String,
        default: ''
      },

      canSelectCard: {
        type: Boolean,
        default: true
      },

      cvvInput: {
        type: String,
        default: ''
      }
    },

    computed: {
      ...mapGetters('savedCards', ['savedCards'])
    },

    methods: {
      changeCardHandler(creditCardId) {
        this.$emit('cvv-input-change', '');
        this.$emit('update:modelValue', creditCardId);
      },

      deleteCardHandler(card) {
        const confirmationModalConfig = {
          ctaConfirmText: 'Confirm',
          title: 'Delete Saved Card',
          hideSecondaryCta: true,
          onConfirm: async () => {
            await this.$store.dispatch('savedCards/deleteCard', card.creditCardId);

            // this.$triggerGoogleTrackingEvent('RemoveCreditCard', 'Account');

            this.$triggerNewRelicEvent('RemoveCreditCard', 'Information', 'Removed Saved Credit Card');
          }
        };

        const confirmationMessage = 'Are you sure you want to delete this saved card?';

        const warningMessage = `The card ending in <b>${card.displayText}</b> is being utilized as an auto-reload payment method. Deleting this card will disable auto-reload settings for configured gift cards.`;

        if (card.isUsedToAutoReloadGiftCard) {
          Object.assign(confirmationModalConfig, { primaryText: warningMessage, secondaryText: confirmationMessage });
        }
        else {
          Object.assign(confirmationModalConfig, { primaryText: `Are you sure you want to delete the saved card ending in <b>${card.displayText}</b>?` });
        }

        this.$openModal('confirmation', confirmationModalConfig);
      }
    }
  };
</script>
